// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Tuple2 } from '@daml.js/daml-prim-types/lib/DA/Types';
import Claims from './Claims';

interface RequiredClaimsProps {
  requiredClaims: Tuple2<string, string>[];
}

const RequiredClaims: React.FC<RequiredClaimsProps> = ({ requiredClaims }) => {
  const claims = requiredClaims.map((t) => ({ subject: '[holder]', property: t._1, value: t._2 }));
  return Claims({ claims });
};

export default RequiredClaims;
